<template>
    <div class="flex column between stretch fill">
      <div class="">
        <div class="flex between align-center">
          <i class="fa-2x r16 far fa-bell indicate-text"></i>
          <input class="sm-input r16 flexw xs-font " type="text" v-model="searchNotifications" placeholder="Find Notification">
          <i class="fas fa-times" @click="$set($store.state.show, 'notifications', false)"></i>
        </div>
      </div>
      <div class="xs-font flex center p8"><span @click="$set(show, 'seen', false); $set(show, 'new', true)" :style="show.new ? 'font-weight: 600' : ''">New</span> <code class="p4">/</code> <span @click="$set(show, 'new', false); $set(show, 'seen', true)" :style="show.seen ? 'font-weight: 600' : ''">Seen</span></div>
      <div class="flexw" style="overflow: scroll; -webkit-overflow-scrolling: touch;height: 100%">
        <div v-if="show.new" class="flex column flexz" style="overflow: scroll; -webkit-overflow-scrolling: touch;">
          <div :key="notifyKey" v-for="(notify, notifyKey) in orderBy($store.state.notifications, 'timestamp', -1)">
            <div 
              v-if="!notify.$value.seen && (searchNotifications.length === 0 || JSON.stringify(notify.$value.message.toLowerCase()).indexOf(searchNotifications.toLowerCase()) > -1 || JSON.stringify(notify.$value.id.toLowerCase()).indexOf(searchNotifications.toLowerCase()) > -1 || JSON.stringify(notify.$value.type.toLowerCase()).indexOf(searchNotifications.toLowerCase()) > -1)" 
              class="flex column b16">
              <div class="flex between align-center">
                <router-link class="flex align-center sm-font fill" :to="notify.$value.link" :style="`max-width: ${show.actions[notify.$value.id] ? '40px; overflow-x: scroll; white-space: nowrap' : ''}`">
                  <i class="r8 fa-2x flex center flexz" :class="$store.state.icons[notify.$value.type]"></i>
                  <div class="flex column align-start fill">
                    <code class="xs-font">{{new Date(notify.$value.timestamp).toLocaleDateString('en-US', {})}} {{new Date(notify.$value.timestamp).toLocaleTimeString('en-US', {})}}</code>
                    <b>{{notify.$value.message}}</b>
                    <span v-if="notify.$value.subMessage">{{notify.$value.subMessage}}</span>
                  </div>
                </router-link>
                <a v-if="notify.$value.actions && notify.$value.actions.length > 0" href @click.prevent="$set(show.actions, notify.$value.id, !show.actions[notify.$value.id])" :class="`p8 fas fa-chevron-${show.actions && show.actions[notify.$value.id] ? 'right' : 'left'}`"></a>
                <div v-if="show.actions[notify.$value.id]" class="container fill flex around align-center">
                  <span :key="actionKey" v-for="(action, actionKey) in notify.$value.actions"><a href v-if="action.length > 0 || Object.keys(action).length > 0">{{action}}</a></span>
                </div>
              </div> 
            </div>
          </div>
        </div>
        <div v-if="show.seen" class="flex column flexz" style="overflow: scroll; -webkit-overflow-scrolling: touch;">
          <div :key="notifyKey" class="b16"
          v-for="(notify, notifyKey) in orderBy($store.state.notifications, 'timestamp', -1)">
            <div v-if="notify.$value.seen && (searchNotifications.length === 0 || 
            JSON.stringify(notify.$value).indexOf(searchNotifications.toLowerCase()) > -1)" 
            class="flex column">
              <div class="flex between align-center">
                <router-link class="flex align-center sm-font fill" :to="notify.$value.link" :style="`max-width: ${show.actions[notify.$value.id] ? '40px; overflow-x: scroll; white-space: nowrap' : ''}`">
                  <i class="r8 fa-2x flexz flex center" :class="$store.state.icons[notify.$value.type]"></i>
                  <div class="flex column align-start fill">
                    <itime class="xs-font black" gran="minute" :timestamp="notify.$value.timestamp"></itime>
                    <b>{{notify.$value.message}}</b>
                    <span v-if="notify.$value.subMessage && notify.$value.subMessage.length > 0">{{notify.$value.subMessage}}</span>
                  </div>
                </router-link>
                <a v-if="notify.$value.actions && notify.$value.actions.length > 0" href @click.prevent="$set(show.actions, notify.$value.id, !show.actions[notify.$value.id])" :class="`p8 fas fa-chevron-${show.actions && show.actions[notify.$value.id] ? 'right' : 'left'}`"></a>
                <div v-if="show.actions[notify.$value.id]" class="container fill flex around align-center">
                  <span :key="actionKey" v-for="(action, actionKey) in notify.$value.actions">{{action}}</span>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'

export default {
  components: {},
  data () {
    return {
      controls: ['new', 'share'],
      name: 'Notification',
      newNotify: '',
      newNotifyUsers: [],
      poppedNotification: {},
      response: {},
      searchNotifications: '',
      searchUser: '',
      show: {
        actions: {},
        new: false,
        seen: true
      }
    }
  },
  destroyed () {
    Object.keys(this.$store.state.notifications).forEach((notification) => {
      if (!this.$store.state.notifications[notification].seen) {
        var newNotification = this.$store.state.notifications[notification]
        newNotification.seen = Date.now()
        newNotification.actions = newNotification.actions || []
        this.$store.dispatch('update', {
          id: notification,
          type: 'notifications',
          data: newNotification
        }).then(() => {
          this.$set(this.$store.state.counts, 'notifications', 0)
        })
      }
    })
  },
  methods: {
    respond (comment, notification, user) {
      this.notifications[notification.id].comments.push({
        user,
        comment,
        timestamp: Date.now()
      })
    }
  },
  mixins: [Vue2Filters.mixin],
  mounted () {
    var newNotifications = false
    Object.keys(this.$store.state.notifications).forEach((notification) => {
      if (!this.$store.state.notifications[notification].seen) {
        newNotifications = true
      }
    })
    if (newNotifications) {
      this.show.seen = false
      this.show.new = true
    }
  },
  name: 'notification',
  watch: {
    'this.$store.state.notifications': {
      handler: function () {
        console.log('another notification came')
      }
    }
  }
}
</script>
